/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ReferralManager,
  ReferralManagerInterface,
} from "../../contracts/ReferralManager";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "referral",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stakingPlanId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reason",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "DividendsAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "DividendsClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "referral",
        type: "address",
      },
    ],
    name: "ReferralAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "referral",
        type: "address",
      },
    ],
    name: "ReferrerSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "subscriber",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "levels",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Subscribed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "REFERRAL_PERCENTS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SUBSCRIPTION_LEVELS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SUBSCRIPTION_PERIOD_DAYS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_LEVELS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "reward",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "referral",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "level",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingPlanId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "reason",
            type: "uint256",
          },
        ],
        internalType: "struct IReferralManager.AddDividendsParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "addUserDividends",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "calculateRefReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "claimDividends",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "extract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "fullSubscriptionCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSubscriptionReferralLevels",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalReferralLevels",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUser1LvlReferrals",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
    ],
    name: "getUserInfo",
    outputs: [
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        internalType: "uint256[10]",
        name: "activeLevels",
        type: "uint256[10]",
      },
      {
        internalType: "uint256",
        name: "totalDividends",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalClaimedDividends",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "referrals_1_lvl",
        type: "address[]",
      },
      {
        internalType: "uint256[15]",
        name: "refCount",
        type: "uint256[15]",
      },
      {
        internalType: "uint256",
        name: "totalReferrals",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isActiveSubscriber",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "hasActivatePowerA",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "activationDate",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "getUserReferralsByLevel",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "referralAddress",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "level",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "activationDate",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isReferralSubscriptionActive",
            type: "bool",
          },
        ],
        internalType: "struct IReferralManager.Referral[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getUserReferrer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractManager_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "fullSubscriptionCost_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "levelSubscriptionCost_",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "levelSubscriptionCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "renewPowerSubscriptionA",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "setMyReferrer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "setUserReferrer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "subscribeToAllLevels",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "subscribeToLevel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256",
      },
    ],
    name: "updateFullSubscriptionCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256",
      },
    ],
    name: "updateLevelSubscriptionCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "percent",
        type: "uint256",
      },
    ],
    name: "updateReferralPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "durationDays",
        type: "uint256",
      },
    ],
    name: "updateSubscriptionPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "userHasActivatedPowerA",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "userHasActivePowerA",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "userHasAnySubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "userHasFullSubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "userHasSubscription",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ReferralManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ReferralManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ReferralManager__factory extends ContractFactory {
  constructor(...args: ReferralManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<ReferralManager> {
    return super.deploy(overrides || {}) as Promise<ReferralManager>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ReferralManager {
    return super.attach(address) as ReferralManager;
  }
  override connect(signer: Signer): ReferralManager__factory {
    return super.connect(signer) as ReferralManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ReferralManagerInterface {
    return new utils.Interface(_abi) as ReferralManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ReferralManager {
    return new Contract(address, _abi, signerOrProvider) as ReferralManager;
  }
}
